/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { skippedBulkDependencySchema } from './skippedBulkDependencySchema';

export const bulkScenarioDependencyResponseSchema = z.object({
  changedCount: z.int(),
  get skipped() {
    return z.array(skippedBulkDependencySchema);
  },
});
